import React, { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SystemMasterTabel from '../../Components/SystemMasterTabel/SystemMasterTabel';
import * as action from './Store/SystemMasters.action';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';

const tempObj = {
  name: null,
  isEmpty: false,
  isNew: true,
  isActive: true,
  hasLength: false,
  _id: '',
  catOneIds: [],
  aliasName: '',
};

function Category2Master() {
  const dispatch = useDispatch();
  const reducer = useSelector((estate) => estate);
  const {
    SystemMastersDetails: { category1List, category2List, userAccessCategories2 },
    UserDetails: { userInfo },
    Users: { logInRights },
  } = reducer;
  const { CheckActionPermission } = useComponent();
  const MasterAddEditAccess = CheckActionPermission(logInRights, 'masters', 'category', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(logInRights, 'masters', 'category', 'delete');
  const { t } = useTranslation('common');
  const loggedInUserId = userInfo.userId;
  const loggedInUserRole = userInfo.role;

  const [isLoadingCat2, setIsLoadingCat2] = useState(false);
  const [showCat2, setShowCat2] = useState(false);
  const [isCategory2Unique, setIsCategory2Unique] = useState(true);
  const [buttonDownCat2, setButtonDownCat2] = useState(true);
  const [cat2BtnDisable, setCat2BtnDisable] = useState(false);
  const [addingCat2, setAddingCat2] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showConfirmationAD, setShowConfirmationAD] = useState(false);
  const [isLoadingConf, setIsLoadingConf] = useState(false);
  const [isCat2, setIsCat2] = useState(false);
  const [cat2Data, setCat2Data] = useState([]);
  const [isUniqCat2Id, setIsUniqCat2Id] = useState([]);
  const [allowedcategoriesId, setAllowedCategoriesId] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [activeInactiveID, setActiveInactiveID] = useState('');
  const [catBasedOnPTData, setCatBasedOnPTData] = useState(false);

  useEffect(() => {
    const fetchCatBasedOnPTData = async () => {
      const catBasedOnPTRes = await dispatch(action.getCatBasedOnPT());
      setCatBasedOnPTData(catBasedOnPTRes);
    };
    fetchCatBasedOnPTData();
  }, [dispatch]);

  // Ensure fresh data on initial mount (helps after redirects or when redux cache is stale)
  useEffect(() => {
    (async () => {
      // Always refresh Category 1 (used for Cat2's Cat1 multi-select)
      await dispatch(
        action.getCategory1Details({
          accessedFrom: 'masters',
          categoryType: 1,
          loggedInUserId,
          isMaster: loggedInUserRole === 'User',
        }),
      );

      // Always refresh Category 2
      const cat2Params = {
        accessedFrom: 'masters',
        categoryType: 2,
        loggedInUserId,
      };
      if (loggedInUserRole === 'User') {
        cat2Params.isMaster = true;
        dispatch(action.getuserCategoriesDetails({ type: 2 }));
      }
      await dispatch(action.getCategory2Details(cat2Params));
    })();
  }, [dispatch, loggedInUserId, loggedInUserRole]);

  useEffect(() => {
    setCat2Data(category2List);
    if (addingCat2) {
      setCat2Data([
        ...category2List,
        {
          name: null,
          isEmpty: false,
          isNew: true,
          isActive: true,
          _id: '',
          aliasName: '',
          catOneIds: [],
        },
      ]);
    }
  }, [category2List, addingCat2]);

  useEffect(() => {
    if (userAccessCategories2 && !isEmpty(userAccessCategories2)) {
      setAllowedCategoriesId(userAccessCategories2?.map((element) => element?._id));
    }
  }, [userAccessCategories2]);

  const callApi = async () => {
    setButtonDownCat2(!buttonDownCat2);
    setIsLoadingCat2(true);
    buttonDownCat2 ? setShowCat2(true) : setShowCat2(false);
    const cat2Params = {
      accessedFrom: 'masters',
      categoryType: 2,
      loggedInUserId,
    };

    if (isEmpty(category1List)) {
      await dispatch(
        action.getCategory1Details({
          accessedFrom: 'masters',
          categoryType: 1,
          loggedInUserId,
          isMaster: loggedInUserRole === 'User',
        }),
      );
    }

    if (isEmpty(cat2Data)) {
      if (loggedInUserRole === 'User') {
        cat2Params.isMaster = true;
        dispatch(action.getuserCategoriesDetails({ type: 2 }));
      }
      await dispatch(action.getCategory2Details(cat2Params));
    }
    setIsLoadingCat2(false);
  };

  const handleChanged = (event, i) => {
    const categories2 = [...cat2Data];
    setIsCategory2Unique(true);
    setIsUniqCat2Id([]);
    if (event.target.name === 'aliasName') {
      categories2[i] = {
        ...categories2[i],
        aliasName: event.target.value,
      };
    } else if (event.target.name === 'catOneIds') {
      const nextCatOneIds = Array.isArray(event.target.value) ? event.target.value : [];
      categories2[i] = {
        ...categories2[i],
        catOneIds: nextCatOneIds,
        isEmpty: nextCatOneIds.length === 0 || categories2[i]?.isEmpty,
      };
    } else {
      categories2[i] = {
        ...categories2[i],
        name: event.target.value,
        isEmpty: event.target.value === '',
      };
    }
    const arr = [];
    const arrIndex = [];
    categories2.forEach((ele, ind) => {
      categories2.forEach((objs, index) => {
        if (ele.name === objs.name && ind !== index) {
          arr.push(ele);
          arrIndex.push(index);
        }
      });
    });
    if (!isEmpty(arr)) {
      const arrs = [...arrIndex];
      const removeArss = Math.min(...arrs);
      const newArr = arrIndex.filter((ele) => ele !== removeArss);
      setIsUniqCat2Id([...newArr]);
    }
    setIsCategory2Unique(isEmpty(arr));
    let isDisableCat2 = false;
    categories2.forEach((category2Element) => {
      if (isEmpty(category2Element?.name?.trim())) {
        isDisableCat2 = true;
      }
    });
    setCat2BtnDisable(isDisableCat2);
    setCat2Data(categories2);
  };

  const addCat2 = async () => {
    if (!showCat2) {
      setAddingCat2(true);
      setButtonDownCat2(!buttonDownCat2);
      setIsLoadingCat2(true);
      buttonDownCat2 ? setShowCat2(true) : setShowCat2(false);
      const cat2Params = {
        accessedFrom: 'masters',
        categoryType: 2,
        loggedInUserId,
      };
      if (loggedInUserRole === 'User') {
        cat2Params.isMaster = true;
        dispatch(action.getuserCategoriesDetails({ type: 2 }));
      }
      isEmpty(cat2Data) && (await dispatch(action.getCategory2Details(cat2Params)));
      setIsLoadingCat2(false);
    } else if (!isEmpty(cat2Data)) {
      setCat2Data([...cat2Data, tempObj]);
    } else {
      setCat2Data([tempObj]);
    }
  };
  const handleDelete = (id) => {
    if (typeof id === 'number' || id === '') {
      // Remove only the targeted item
      cat2Data.splice(id, 1);
      cat2Data.forEach((category2Element) => {
        if (isEmpty(category2Element?.name?.trim()) && category2Element.isNew) {
          setCat2BtnDisable(true);
        } else {
          setCat2BtnDisable(false);
        }
      });
      setIsUniqCat2Id([]);
      setIsCategory2Unique(true);
      setCat2Data([...cat2Data]);
    } else {
      setDeleteId(id);
      setShowConfirmation(true);
    }
  };

  const saveCat2 = async () => {
    setIsCat2(true);
    if (!isEmpty(cat2Data)) {
      const emptyField = cat2Data.filter((c2item) => {
        const nameMissing = c2item.name === null || c2item.name === '';
        const c1Missing = !Array.isArray(c2item?.catOneIds) || c2item.catOneIds.length === 0;
        return catBasedOnPTData ? nameMissing || c1Missing : nameMissing;
      });

      if (isEmpty(emptyField)) {
        const data = cat2Data.map((ca2obj) => {
          const c1Ids = Array.isArray(ca2obj?.catOneIds) ? ca2obj.catOneIds : [];
          const next = {
            ...ca2obj,
            name: ca2obj?.name?.trim(),
            aliasName: ca2obj?.aliasName ? ca2obj.aliasName.trim() : '',
          };
          if (catBasedOnPTData) {
            next.catOneIds = c1Ids;
          } else {
            // Remove catOneIds entirely when independent mode
            delete next.catOneIds;
          }
          return next;
        });

        const cat2DeleteParams = {
          loggedInUserId,
          categoriesName: JSON.stringify(data),
          categoryType: 2,
          title: t('CATEGORY2.CATEGORIESS'),
          showAlias: true,
        };
        setAddingCat2(false);
        await dispatch(action.saveToSystemMaster(cat2DeleteParams, t));
        const cat2Params = {
          accessedFrom: 'masters',
          categoryType: 2,
          loggedInUserId,
        };
        if (loggedInUserRole === 'User') {
          cat2Params.isMaster = true;
          dispatch(action.getuserCategoriesDetails({ type: 2 }));
        }
        await dispatch(action.getCategory2Details(cat2Params));
        // post API
      } else {
        const newState = cat2Data.map((c2obj) => {
          const nameMissing = c2obj.name === null || c2obj.name === '';
          const c1Missing = !Array.isArray(c2obj?.catOneIds) || c2obj.catOneIds.length === 0;
          const shouldFlag = catBasedOnPTData ? nameMissing || c1Missing : nameMissing;
          return !c2obj?.isEmpty && shouldFlag ? { ...c2obj, isEmpty: true } : c2obj;
        });
        setCat2Data(newState);
      }
    }
    setIsCat2(false);
  };

  const activeInactiveClicked = (id) => {
    setShowConfirmationAD(true);
    setActiveInactiveID(id);
  };

  useEffect(() => {
    const array = [];
    cat2Data.forEach((ele, index) => {
      cat2Data.forEach((obj, places) => {
        if (index !== places && ele?.name === obj?.name) {
          array.push(ele);
        }
      });
    });
    if (isEmpty(array)) {
      setIsCategory2Unique(isEmpty(array));
      setIsUniqCat2Id([]);
    }
  }, [cat2Data]);

  const deleteConfirmed = async () => {
    setIsLoadingConf(true);
    const category2Params = {
      categoryType: 2,
      loggedInUserId,
      wantToDeleteCategoryId: deleteId,
      title: t('CATEGORY2.CATEGORIES'),
    };
    await dispatch(action.deleteFromSystemMasters(category2Params, t));
    setIsLoadingConf(false);
    setShowConfirmation(false);
    setCat2Data([...category2List]);
    const cat2Params = {
      accessedFrom: 'masters',
      categoryType: 2,
      loggedInUserId,
    };
    if (loggedInUserRole === 'User') {
      cat2Params.isMaster = true;
      dispatch(action.getuserCategoriesDetails({ type: 2 }));
    }
    await dispatch(action.getCategory2Details(cat2Params));
  };

  const activeInactiveConfirmed = async () => {
    setIsLoadingConf(true);
    let c2 = {};
    cat2Data.forEach((ele) => {
      if (ele._id === activeInactiveID) {
        ele.isActive = !ele.isActive;
        const data = {
          ...ele,
          loggedInUserId,
          title: t('CATEGORY2.CATEGORIES'),
        };
        c2 = data;
      }
    });
    await dispatch(action.setActiveInactive(c2, t));
    setIsLoadingConf(false);
    setShowConfirmationAD(false);
    setCat2Data([...cat2Data]);
  };

  return (
    <>
      <SystemMasterTabel
        isLoading={isLoadingCat2}
        setShow={showCat2}
        callApi={callApi}
        buttonDown={buttonDownCat2}
        mainData={cat2Data}
        category1List={category1List}
        addLimit
        nameMaxLength={40}
        handleChanged={handleChanged}
        addBtnClicked={addCat2}
        deletPressed={handleDelete}
        onSave={saveCat2}
        isDesabled={isCat2}
        title={t('CATEGORY2.TITLE')}
        masterAddEditAccess={MasterAddEditAccess}
        masterDeleteAccess={MasterDeleteAccess}
        inputName="category2"
        activeInactiveClicked={activeInactiveClicked}
        btnDisable={cat2BtnDisable}
        isUnique={isCategory2Unique}
        isUniqueId={isUniqCat2Id}
        allowedIds={allowedcategoriesId}
        showAlias
        placeholder="Enter Category 2"
        catBasedOnPTData={catBasedOnPTData}
      />
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={() => deleteConfirmed()}
          title={t('CATEGORY2.DELETE_CONFIRM_TITLE')}
          message={t('CATEGORY2.DELETE_CONFIRM_MESSAGE')}
          toggle={() => setShowConfirmation(!showConfirmation)}
          loading={isLoadingConf}
        />
      )}
      {showConfirmationAD && (
        <ConfirmationPopup
          onOpen={showConfirmationAD}
          onConfirm={() => activeInactiveConfirmed()}
          title={t('CATEGORY2.ACTIVATE_DEACTIVATE_CONFIRM_TITLE')}
          message={t('CATEGORY2.ACTIVATE_DEACTIVATE_CONFIRM_MESSAGE')}
          toggle={() => setShowConfirmationAD(!showConfirmationAD)}
          loading={isLoadingConf}
        />
      )}
    </>
  );
}
export default Category2Master;
